<script lang="ts" setup>
import SiteHeader from '@/components/SiteHeader.vue'

withDefaults(
  defineProps<{
    transition?: string | boolean
    scrollStrategy?: 'none' | 'block' | 'close' | 'reposition'
    showHeader?: boolean
    closeOnBack?: boolean
  }>(),
  {
    transition: 'fade-transition',
    scrollStrategy: 'block',
    showHeader: true,
    closeOnBack: true,
  }
)

const modelValue = defineModel<boolean>({ default: true })
</script>

<template>
  <v-dialog
    v-model="modelValue"
    fullscreen
    :scrim="false"
    persistent
    no-click-animation
    content-class="overlay"
    :transition="transition"
    :scroll-strategy="scrollStrategy"
    :close-on-back="closeOnBack"
  >
    <slot v-if="showHeader" name="header">
      <site-header :overlay="true" />
    </slot>
    <slot />
  </v-dialog>
</template>

<style lang="scss">
.overlay {
  background: $c-white;
}
</style>
